export const saudiGallery = [
  {
    id: 1,
    image: 'https://public.readdy.ai/ai/img_res/114791cde37e074830637c3f84731c75.jpg',
    title: 'Masjid al-Haram, Makkah',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20view%20of%20the%20Prophet%20Mosque%20Masjid%20an-Nabawi%20in%20Madinah%20Saudi%20Arabia%20with%20iconic%20green%20dome%20and%20tall%20minarets%20illuminated%20at%20dusk%20with%20warm%20golden%20lights%20pilgrims%20walking%20on%20marble%20courtyard%20peaceful%20Islamic%20architecture&width=600&height=800&seq=saudi-gallery-002&orientation=portrait',
    title: 'Masjid an-Nabawi, Madinah',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20view%20of%20ancient%20Nabataean%20tombs%20carved%20into%20golden%20sandstone%20cliffs%20in%20AlUla%20Saudi%20Arabia%20with%20dramatic%20rock%20formations%20and%20desert%20landscape%20under%20clear%20blue%20sky%20archaeological%20heritage%20site&width=600&height=600&seq=saudi-gallery-003&orientation=squarish',
    title: 'AlUla Heritage Site',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Modern%20skyline%20of%20Riyadh%20Saudi%20Arabia%20at%20sunset%20featuring%20Kingdom%20Centre%20tower%20and%20contemporary%20skyscrapers%20against%20warm%20orange%20and%20purple%20sky%20urban%20development%20and%20futuristic%20architecture&width=600&height=600&seq=saudi-gallery-004&orientation=squarish',
    title: 'Riyadh Skyline',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Pristine%20turquoise%20waters%20and%20white%20sandy%20beach%20along%20the%20Red%20Sea%20coast%20in%20Saudi%20Arabia%20with%20coral%20reefs%20visible%20through%20crystal%20clear%20water%20luxury%20resort%20in%20background%20tropical%20paradise&width=800&height=600&seq=saudi-gallery-005&orientation=landscape',
    title: 'Red Sea Coast',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Historic%20Diriyah%20mud-brick%20architecture%20in%20Riyadh%20Saudi%20Arabia%20with%20traditional%20Najdi%20style%20buildings%20and%20fortifications%20under%20golden%20sunlight%20UNESCO%20World%20Heritage%20site%20cultural%20heritage&width=600&height=600&seq=saudi-gallery-006&orientation=squarish',
    title: 'Diriyah Historic District',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20desert%20landscape%20in%20Saudi%20Arabia%20with%20golden%20sand%20dunes%20and%20clear%20blue%20sky%20traditional%20Bedouin%20camp%20with%20tents%20in%20the%20distance%20Arabian%20desert%20adventure&width=600&height=800&seq=saudi-gallery-007&orientation=portrait',
    title: 'Arabian Desert',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20traditional%20Saudi%20Arabian%20market%20souq%20with%20colorful%20spices%20textiles%20and%20handicrafts%20displayed%20in%20wooden%20stalls%20warm%20ambient%20lighting%20authentic%20cultural%20shopping%20experience&width=600&height=600&seq=saudi-gallery-008&orientation=squarish',
    title: 'Traditional Souq',
    size: 'normal'
  }
];

export const turkeyGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20Istanbul%20Turkey%20featuring%20the%20Blue%20Mosque%20and%20Hagia%20Sophia%20with%20their%20iconic%20domes%20and%20minarets%20across%20the%20Bosphorus%20strait%20at%20golden%20sunset%20Ottoman%20architecture&width=800&height=600&seq=turkey-gallery-001&orientation=landscape',
    title: 'Istanbul Skyline',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Magical%20hot%20air%20balloons%20floating%20over%20fairy%20chimneys%20and%20unique%20rock%20formations%20in%20Cappadocia%20Turkey%20at%20sunrise%20with%20warm%20golden%20light%20and%20pink%20sky%20surreal%20landscape&width=600&height=800&seq=turkey-gallery-002&orientation=portrait',
    title: 'Cappadocia Balloons',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20turquoise%20waters%20of%20Oludeniz%20beach%20in%20Antalya%20Turkey%20with%20white%20sandy%20shore%20surrounded%20by%20lush%20green%20mountains%20paragliders%20in%20the%20sky%20Mediterranean%20paradise&width=600&height=600&seq=turkey-gallery-003&orientation=squarish',
    title: 'Oludeniz Beach',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Roman%20Library%20of%20Celsus%20in%20Ephesus%20Turkey%20with%20impressive%20classical%20columns%20and%20facade%20under%20clear%20blue%20sky%20archaeological%20ruins%20historical%20heritage&width=600&height=600&seq=turkey-gallery-004&orientation=squarish',
    title: 'Ephesus Ruins',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20white%20travertine%20terraces%20of%20Pamukkale%20Turkey%20with%20cascading%20thermal%20pools%20filled%20with%20turquoise%20water%20against%20bright%20blue%20sky%20natural%20wonder%20UNESCO%20site&width=800&height=600&seq=turkey-gallery-005&orientation=landscape',
    title: 'Pamukkale Terraces',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20traditional%20Turkish%20lanterns%20and%20lamps%20hanging%20in%20Grand%20Bazaar%20Istanbul%20with%20intricate%20mosaic%20patterns%20warm%20ambient%20lighting%20authentic%20market%20atmosphere&width=600&height=600&seq=turkey-gallery-006&orientation=squarish',
    title: 'Grand Bazaar',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Majestic%20interior%20of%20Blue%20Mosque%20in%20Istanbul%20Turkey%20with%20stunning%20blue%20Iznik%20tiles%20ornate%20Islamic%20calligraphy%20and%20grand%20chandeliers%20spiritual%20Ottoman%20architecture&width=600&height=800&seq=turkey-gallery-007&orientation=portrait',
    title: 'Blue Mosque Interior',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Scenic%20view%20of%20traditional%20Turkish%20gulet%20wooden%20sailing%20boat%20on%20crystal%20clear%20turquoise%20Mediterranean%20waters%20along%20the%20Turkish%20Riviera%20with%20rocky%20coastline%20luxury%20cruise&width=600&height=600&seq=turkey-gallery-008&orientation=squarish',
    title: 'Turkish Riviera',
    size: 'normal'
  }
];

export const uaeGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20view%20of%20Burj%20Khalifa%20towering%20over%20Dubai%20skyline%20at%20sunset%20with%20modern%20skyscrapers%20and%20Dubai%20Fountain%20in%20foreground%20warm%20golden%20light%20futuristic%20architecture&width=800&height=600&seq=uae-gallery-001&orientation=landscape',
    title: 'Burj Khalifa',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Magnificent%20Sheikh%20Zayed%20Grand%20Mosque%20in%20Abu%20Dhabi%20UAE%20with%20white%20marble%20domes%20and%20minarets%20reflected%20in%20water%20pools%20at%20dusk%20with%20blue%20hour%20lighting%20Islamic%20architecture&width=600&height=800&seq=uae-gallery-002&orientation=portrait',
    title: 'Sheikh Zayed Mosque',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20desert%20safari%20camp%20in%20Dubai%20UAE%20with%20traditional%20Bedouin%20tents%20on%20golden%20sand%20dunes%20at%20sunset%20with%20warm%20orange%20sky%20Arabian%20adventure&width=600&height=600&seq=uae-gallery-003&orientation=squarish',
    title: 'Desert Safari',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Palm%20Jumeirah%20artificial%20island%20in%20Dubai%20UAE%20with%20luxury%20villas%20and%20Atlantis%20hotel%20surrounded%20by%20turquoise%20Persian%20Gulf%20waters%20engineering%20marvel&width=600&height=600&seq=uae-gallery-004&orientation=squarish',
    title: 'Palm Jumeirah',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20Dubai%20Marina%20skyline%20at%20night%20with%20illuminated%20modern%20skyscrapers%20reflected%20in%20calm%20water%20luxury%20yachts%20docked%20along%20the%20promenade%20urban%20luxury&width=800&height=600&seq=uae-gallery-005&orientation=landscape',
    title: 'Dubai Marina',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20abra%20water%20taxi%20boats%20on%20Dubai%20Creek%20with%20historic%20wind%20towers%20and%20old%20souq%20buildings%20in%20background%20authentic%20heritage%20area&width=600&height=600&seq=uae-gallery-006&orientation=squarish',
    title: 'Dubai Creek',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20interior%20of%20Dubai%20Mall%20aquarium%20with%20massive%20glass%20tunnel%20surrounded%20by%20sharks%20and%20rays%20swimming%20overhead%20blue%20ambient%20lighting%20family%20entertainment&width=600&height=800&seq=uae-gallery-007&orientation=portrait',
    title: 'Dubai Aquarium',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20spice%20and%20gold%20souq%20market%20in%20Dubai%20UAE%20with%20traditional%20stalls%20displaying%20aromatic%20spices%20textiles%20and%20jewelry%20warm%20ambient%20lighting%20authentic%20shopping&width=600&height=600&seq=uae-gallery-008&orientation=squarish',
    title: 'Traditional Souq',
    size: 'normal'
  }
];

export const moroccoGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Marrakesh%20medina%20Morocco%20with%20Koutoubia%20Mosque%20minaret%20rising%20above%20terracotta%20rooftops%20and%20narrow%20streets%20at%20golden%20sunset%20traditional%20Islamic%20architecture&width=800&height=600&seq=morocco-gallery-001&orientation=landscape',
    title: 'Marrakesh Medina',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Picturesque%20blue-washed%20streets%20and%20buildings%20of%20Chefchaouen%20Morocco%20with%20traditional%20doors%20and%20potted%20plants%20against%20vibrant%20blue%20walls%20charming%20mountain%20town&width=600&height=800&seq=morocco-gallery-002&orientation=portrait',
    title: 'Chefchaouen Blue City',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Golden%20sand%20dunes%20of%20Sahara%20Desert%20in%20Morocco%20with%20camel%20caravan%20silhouetted%20against%20orange%20sunset%20sky%20dramatic%20desert%20landscape%20adventure&width=600&height=600&seq=morocco-gallery-003&orientation=squarish',
    title: 'Sahara Desert',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Ornate%20interior%20courtyard%20of%20traditional%20Moroccan%20riad%20with%20colorful%20mosaic%20tiles%20carved%20wooden%20doors%20fountain%20and%20lush%20plants%20authentic%20architecture&width=600&height=600&seq=morocco-gallery-004&orientation=squarish',
    title: 'Traditional Riad',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20Jemaa%20el-Fnaa%20square%20in%20Marrakesh%20Morocco%20at%20dusk%20with%20food%20stalls%20street%20performers%20and%20crowds%20of%20people%20warm%20ambient%20lighting%20cultural%20hub&width=800&height=600&seq=morocco-gallery-005&orientation=landscape',
    title: 'Jemaa el-Fnaa Square',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20medieval%20walls%20and%20gates%20of%20Fes%20medina%20Morocco%20with%20traditional%20Islamic%20architecture%20and%20narrow%20alleyways%20UNESCO%20World%20Heritage%20site&width=600&height=600&seq=morocco-gallery-006&orientation=squarish',
    title: 'Fes Medina',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20snow-capped%20peaks%20of%20Atlas%20Mountains%20in%20Morocco%20with%20traditional%20Berber%20villages%20on%20hillsides%20and%20green%20valleys%20below%20mountain%20landscape&width=600&height=800&seq=morocco-gallery-007&orientation=portrait',
    title: 'Atlas Mountains',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20traditional%20Moroccan%20spices%20displayed%20in%20cone-shaped%20piles%20at%20souq%20market%20with%20vibrant%20reds%20yellows%20and%20oranges%20aromatic%20authentic%20shopping&width=600&height=600&seq=morocco-gallery-008&orientation=squarish',
    title: 'Spice Market',
    size: 'normal'
  }
];

export const egyptGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Majestic%20Great%20Pyramids%20of%20Giza%20and%20Sphinx%20in%20Egypt%20at%20golden%20sunset%20with%20warm%20orange%20sky%20ancient%20limestone%20structures%20rising%20from%20desert%20sands%20archaeological%20wonder&width=800&height=600&seq=egypt-gallery-001&orientation=landscape',
    title: 'Pyramids of Giza',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20interior%20of%20ancient%20Egyptian%20temple%20in%20Luxor%20with%20massive%20carved%20columns%20covered%20in%20hieroglyphics%20and%20colorful%20wall%20paintings%20dramatic%20lighting%20pharaonic%20architecture&width=600&height=800&seq=egypt-gallery-002&orientation=portrait',
    title: 'Luxor Temple',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20wooden%20felucca%20sailboat%20on%20the%20Nile%20River%20in%20Egypt%20at%20sunset%20with%20white%20sails%20and%20palm%20trees%20along%20the%20riverbank%20peaceful%20cruise&width=600&height=600&seq=egypt-gallery-003&orientation=squarish',
    title: 'Nile River Cruise',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Crystal%20clear%20turquoise%20waters%20of%20the%20Red%20Sea%20in%20Egypt%20with%20vibrant%20coral%20reefs%20and%20tropical%20fish%20underwater%20diving%20paradise&width=600&height=600&seq=egypt-gallery-004&orientation=squarish',
    title: 'Red Sea Diving',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Bustling%20Khan%20el-Khalili%20bazaar%20in%20Cairo%20Egypt%20with%20colorful%20lanterns%20textiles%20and%20handicrafts%20hanging%20from%20stalls%20warm%20ambient%20lighting%20traditional%20market&width=800&height=600&seq=egypt-gallery-005&orientation=landscape',
    title: 'Khan el-Khalili Bazaar',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Abu%20Simbel%20temples%20in%20Egypt%20with%20massive%20statues%20of%20Ramses%20II%20carved%20into%20rock%20cliff%20face%20beside%20Lake%20Nasser%20under%20clear%20blue%20sky%20UNESCO%20site&width=600&height=600&seq=egypt-gallery-006&orientation=squarish',
    title: 'Abu Simbel Temples',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Islamic%20architecture%20of%20Muhammad%20Ali%20Mosque%20in%20Cairo%20Egypt%20with%20Ottoman%20style%20domes%20and%20minarets%20illuminated%20at%20dusk%20with%20golden%20lights&width=600&height=800&seq=egypt-gallery-007&orientation=portrait',
    title: 'Muhammad Ali Mosque',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Pristine%20white%20sandy%20beach%20in%20Sharm%20el-Sheikh%20Egypt%20with%20turquoise%20Red%20Sea%20waters%20palm%20trees%20and%20luxury%20resort%20in%20background%20tropical%20paradise&width=600&height=600&seq=egypt-gallery-008&orientation=squarish',
    title: 'Sharm el-Sheikh Beach',
    size: 'normal'
  }
];

export const jordanGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20view%20of%20the%20Treasury%20Al-Khazneh%20in%20Petra%20Jordan%20carved%20into%20rose-red%20sandstone%20cliff%20with%20classical%20columns%20framed%20by%20narrow%20canyon%20walls%20ancient%20wonder&width=800&height=600&seq=jordan-gallery-001&orientation=landscape',
    title: 'Petra Treasury',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20red%20desert%20landscape%20of%20Wadi%20Rum%20Jordan%20with%20massive%20sandstone%20rock%20formations%20and%20mountains%20under%20clear%20blue%20sky%20Martian%20terrain%20adventure&width=600&height=800&seq=jordan-gallery-002&orientation=portrait',
    title: 'Wadi Rum Desert',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Person%20floating%20effortlessly%20in%20the%20turquoise%20waters%20of%20the%20Dead%20Sea%20in%20Jordan%20with%20salt%20formations%20and%20mountains%20in%20background%20unique%20natural%20experience&width=600&height=600&seq=jordan-gallery-003&orientation=squarish',
    title: 'Dead Sea',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Roman%20ruins%20of%20Jerash%20in%20Jordan%20with%20impressive%20colonnaded%20streets%20and%20stone%20arches%20under%20bright%20blue%20sky%20archaeological%20site&width=600&height=600&seq=jordan-gallery-004&orientation=squarish',
    title: 'Jerash Ruins',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Amman%20Jordan%20cityscape%20at%20sunset%20with%20white%20stone%20buildings%20on%20hills%20and%20Roman%20amphitheater%20in%20foreground%20warm%20golden%20light%20capital%20city&width=800&height=600&seq=jordan-gallery-005&orientation=landscape',
    title: 'Amman Cityscape',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Bedouin%20camp%20in%20Wadi%20Rum%20Jordan%20with%20black%20goat%20hair%20tents%20on%20red%20desert%20sand%20at%20sunset%20authentic%20cultural%20experience&width=600&height=600&seq=jordan-gallery-006&orientation=squarish',
    title: 'Bedouin Camp',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20view%20from%20Mount%20Nebo%20in%20Jordan%20overlooking%20the%20Dead%20Sea%20and%20Jordan%20Valley%20with%20ancient%20Byzantine%20mosaics%20biblical%20site&width=600&height=800&seq=jordan-gallery-007&orientation=portrait',
    title: 'Mount Nebo',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20traditional%20Jordanian%20handicrafts%20and%20souvenirs%20displayed%20at%20market%20stall%20including%20pottery%20textiles%20and%20sand%20art%20bottles%20authentic%20shopping&width=600&height=600&seq=jordan-gallery-008&orientation=squarish',
    title: 'Traditional Crafts',
    size: 'normal'
  }
];

export const malaysiaGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20view%20of%20Petronas%20Twin%20Towers%20illuminated%20at%20night%20in%20Kuala%20Lumpur%20Malaysia%20with%20KLCC%20park%20fountain%20in%20foreground%20modern%20Islamic%20architecture%20iconic%20skyline&width=800&height=600&seq=malaysia-gallery-001&orientation=landscape',
    title: 'Petronas Twin Towers',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Batu%20Caves%20temple%20in%20Malaysia%20with%20giant%20golden%20statue%20of%20Lord%20Murugan%20and%20colorful%20rainbow%20stairs%20leading%20to%20limestone%20cave%20entrance%20cultural%20landmark&width=600&height=800&seq=malaysia-gallery-002&orientation=portrait',
    title: 'Batu Caves',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Pristine%20white%20sandy%20beach%20in%20Langkawi%20Malaysia%20with%20crystal%20clear%20turquoise%20waters%20palm%20trees%20and%20limestone%20cliffs%20in%20background%20tropical%20island%20paradise&width=600&height=600&seq=malaysia-gallery-003&orientation=squarish',
    title: 'Langkawi Beach',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20street%20art%20murals%20on%20historic%20buildings%20in%20George%20Town%20Penang%20Malaysia%20with%20traditional%20shophouses%20and%20vibrant%20cultural%20heritage%20UNESCO%20site&width=600&height=600&seq=malaysia-gallery-004&orientation=squarish',
    title: 'Penang Street Art',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Delicious%20Malaysian%20halal%20food%20spread%20including%20nasi%20lemak%20satay%20rendang%20and%20roti%20canai%20on%20traditional%20banana%20leaf%20vibrant%20colors%20authentic%20cuisine&width=800&height=600&seq=malaysia-gallery-005&orientation=landscape',
    title: 'Halal Malaysian Cuisine',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Majestic%20Sultan%20Salahuddin%20Abdul%20Aziz%20Mosque%20Blue%20Mosque%20in%20Shah%20Alam%20Malaysia%20with%20large%20blue%20dome%20and%20tall%20minarets%20Islamic%20architecture&width=600&height=600&seq=malaysia-gallery-006&orientation=squarish',
    title: 'Blue Mosque',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Lush%20green%20Cameron%20Highlands%20tea%20plantations%20in%20Malaysia%20with%20rolling%20hills%20covered%20in%20tea%20bushes%20and%20misty%20mountains%20in%20background%20scenic%20landscape&width=600&height=800&seq=malaysia-gallery-007&orientation=portrait',
    title: 'Cameron Highlands',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Malaysian%20wooden%20houses%20on%20stilts%20in%20water%20village%20with%20wooden%20walkways%20and%20boats%20authentic%20cultural%20heritage%20Kampung%20lifestyle&width=600&height=600&seq=malaysia-gallery-008&orientation=squarish',
    title: 'Water Village',
    size: 'normal'
  }
];

export const indonesiaGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20pristine%20Kuta%20Beach%20in%20Lombok%20Indonesia%20with%20turquoise%20waters%20white%20sandy%20shore%20traditional%20wooden%20boats%20and%20lush%20green%20hills%20tropical%20paradise&width=800&height=600&seq=indonesia-gallery-001&orientation=landscape',
    title: 'Lombok Beach',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Majestic%20Mount%20Rinjani%20volcano%20in%20Lombok%20Indonesia%20with%20crater%20lake%20Segara%20Anak%20surrounded%20by%20dramatic%20mountain%20peaks%20and%20clouds%20trekking%20adventure&width=600&height=800&seq=indonesia-gallery-002&orientation=portrait',
    title: 'Mount Rinjani',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Istiqlal%20Mosque%20in%20Jakarta%20Indonesia%20with%20large%20white%20dome%20and%20tall%20minaret%20largest%20mosque%20in%20Southeast%20Asia%20Islamic%20architecture&width=600&height=600&seq=indonesia-gallery-003&orientation=squarish',
    title: 'Istiqlal Mosque',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Crystal%20clear%20turquoise%20waters%20of%20Gili%20Islands%20in%20Indonesia%20with%20sea%20turtles%20swimming%20near%20coral%20reefs%20snorkeling%20paradise%20marine%20life&width=600&height=600&seq=indonesia-gallery-004&orientation=squarish',
    title: 'Gili Islands',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Indonesian%20halal%20food%20spread%20including%20nasi%20goreng%20satay%20rendang%20and%20gado-gado%20on%20wooden%20table%20vibrant%20colors%20authentic%20Muslim-friendly%20cuisine&width=800&height=600&seq=indonesia-gallery-005&orientation=landscape',
    title: 'Indonesian Halal Cuisine',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20Senggigi%20Beach%20sunset%20in%20Lombok%20Indonesia%20with%20golden%20sky%20reflected%20in%20calm%20waters%20palm%20trees%20silhouetted%20peaceful%20tropical%20evening&width=600&height=600&seq=indonesia-gallery-006&orientation=squarish',
    title: 'Senggigi Sunset',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Sasak%20village%20in%20Lombok%20Indonesia%20with%20unique%20thatched%20roof%20houses%20made%20of%20bamboo%20and%20rice%20straw%20authentic%20cultural%20heritage&width=600&height=800&seq=indonesia-gallery-007&orientation=portrait',
    title: 'Sasak Village',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20traditional%20Indonesian%20market%20with%20colorful%20batik%20textiles%20handicrafts%20and%20spices%20displayed%20in%20wooden%20stalls%20authentic%20shopping%20experience&width=600&height=600&seq=indonesia-gallery-008&orientation=squarish',
    title: 'Traditional Market',
    size: 'normal'
  }
];

export const maldivesGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20luxury%20overwater%20villas%20and%20bungalows%20in%20the%20Maldives%20with%20wooden%20walkways%20over%20crystal%20clear%20turquoise%20lagoon%20surrounded%20by%20coral%20reefs%20tropical%20paradise&width=800&height=600&seq=maldives-gallery-001&orientation=landscape',
    title: 'Overwater Villas',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Underwater%20view%20of%20vibrant%20coral%20reef%20in%20the%20Maldives%20with%20colorful%20tropical%20fish%20sea%20turtles%20and%20manta%20rays%20swimming%20in%20crystal%20clear%20blue%20water%20diving%20paradise&width=600&height=800&seq=maldives-gallery-002&orientation=portrait',
    title: 'Coral Reef Diving',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Pristine%20white%20sandy%20beach%20in%20the%20Maldives%20with%20turquoise%20waters%20palm%20trees%20and%20luxury%20beach%20loungers%20under%20thatched%20umbrellas%20perfect%20tropical%20getaway&width=600&height=600&seq=maldives-gallery-003&orientation=squarish',
    title: 'Private Beach',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20sunset%20dinner%20setup%20on%20the%20beach%20in%20the%20Maldives%20with%20table%20for%20two%20candles%20and%20lanterns%20on%20white%20sand%20with%20orange%20and%20pink%20sky%20luxury%20experience&width=600&height=600&seq=maldives-gallery-004&orientation=squarish',
    title: 'Beach Dining',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Magical%20bioluminescent%20plankton%20glowing%20blue%20in%20the%20ocean%20waters%20at%20night%20in%20the%20Maldives%20with%20stars%20in%20the%20sky%20natural%20phenomenon%20unique%20experience&width=800&height=600&seq=maldives-gallery-005&orientation=landscape',
    title: 'Bioluminescent Beach',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20infinity%20pool%20overlooking%20turquoise%20ocean%20in%20the%20Maldives%20with%20modern%20pool%20loungers%20and%20palm%20trees%20resort%20amenities&width=600&height=600&seq=maldives-gallery-006&orientation=squarish',
    title: 'Infinity Pool',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Maldivian%20dhoni%20wooden%20boat%20sailing%20on%20calm%20turquoise%20waters%20at%20sunset%20with%20orange%20and%20pink%20sky%20authentic%20island%20transport&width=600&height=800&seq=maldives-gallery-007&orientation=portrait',
    title: 'Traditional Dhoni',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Delicious%20halal-certified%20seafood%20platter%20with%20grilled%20fish%20prawns%20and%20lobster%20served%20on%20elegant%20plate%20at%20Maldives%20resort%20Muslim-friendly%20dining&width=600&height=600&seq=maldives-gallery-008&orientation=squarish',
    title: 'Halal Seafood',
    size: 'normal'
  }
];

export const bosniaGallery = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Iconic%20Stari%20Most%20Old%20Bridge%20in%20Mostar%20Bosnia%20and%20Herzegovina%20spanning%20emerald%20green%20Neretva%20River%20with%20traditional%20Ottoman%20stone%20architecture%20and%20historic%20buildings%20UNESCO%20site&width=800&height=600&seq=bosnia-gallery-001&orientation=landscape',
    title: 'Mostar Old Bridge',
    size: 'wide'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Gazi%20Husrev-beg%20Mosque%20in%20Sarajevo%20Bosnia%20with%20Ottoman%20architecture%20large%20dome%20and%20tall%20minaret%20surrounded%20by%20historic%20bazaar%20Islamic%20heritage&width=600&height=800&seq=bosnia-gallery-002&orientation=portrait',
    title: 'Gazi Husrev-beg Mosque',
    size: 'tall'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Charming%20cobblestone%20streets%20of%20Bascarsija%20old%20bazaar%20in%20Sarajevo%20Bosnia%20with%20traditional%20Ottoman%20shops%20copper%20crafts%20and%20cafes%20authentic%20cultural%20quarter&width=600&height=600&seq=bosnia-gallery-003&orientation=squarish',
    title: 'Bascarsija Bazaar',
    size: 'normal'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20Kravica%20Waterfall%20in%20Bosnia%20and%20Herzegovina%20with%20cascading%20water%20falling%20into%20turquoise%20pool%20surrounded%20by%20lush%20green%20forest%20natural%20wonder&width=600&height=600&seq=bosnia-gallery-004&orientation=squarish',
    title: 'Kravica Waterfall',
    size: 'normal'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Sarajevo%20Bosnia%20cityscape%20with%20mix%20of%20Ottoman%20mosques%20Austro-Hungarian%20buildings%20and%20modern%20structures%20surrounded%20by%20green%20mountains%20diverse%20architecture&width=800&height=600&seq=bosnia-gallery-005&orientation=landscape',
    title: 'Sarajevo Cityscape',
    size: 'wide'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Bosnian%20halal%20food%20including%20cevapi%20grilled%20meat%20sausages%20with%20somun%20bread%20and%20ajvar%20sauce%20on%20wooden%20plate%20authentic%20Balkan%20cuisine&width=600&height=600&seq=bosnia-gallery-006&orientation=squarish',
    title: 'Bosnian Halal Cuisine',
    size: 'normal'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Historic%20Mehmed%20Pasha%20Sokolovic%20Bridge%20in%20Visegrad%20Bosnia%20with%20elegant%20stone%20arches%20spanning%20Drina%20River%20surrounded%20by%20green%20hills%20Ottoman%20engineering%20UNESCO%20site&width=600&height=800&seq=bosnia-gallery-007&orientation=portrait',
    title: 'Visegrad Bridge',
    size: 'tall'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Blagaj%20Tekke%20Dervish%20monastery%20built%20into%20cliff%20beside%20turquoise%20Buna%20River%20spring%20in%20Bosnia%20with%20traditional%20Ottoman%20architecture%20spiritual%20site&width=600&height=600&seq=bosnia-gallery-008&orientation=squarish',
    title: 'Blagaj Tekke',
    size: 'normal'
  }
];